import { isUndefined } from '@/core/util';

class Enum {
  constructor(props = []) {
    this.__props = {};
    props.forEach(prop => {
      const { key, value } = prop;
      if (isUndefined(key) || isUndefined(value)) {
        console.error('Enum 缺少必要的key和value');
        return;
      }
      this[key] = value;
      this.__props[value] = prop;
    });
  }

  get(value) {
    return this.__props[value];
  }
}

window.ENUM = {
  SignType: {
    0: '未到',
    1: '到课',
    2: '未到(已补)',
    3: '迟到',
    4: '请假',
    5: '请假(已补)',
  },
  ClassStateType: {
    ABSENCE: '未到',
    ATTEND: '到课',
    EXTRA: '未到(已补)',
    LATE: '迟到',
    LEAVE: '请假',
    LEAVE_EXTRA: '请假(已补)',
  },
  //合同类型
  ContractType: {
    0: '全部',
    1: '新签收据',
    2: '续签收据',
    3: '已废除',
    4: '欠费',
    5: '退课收据',
    6: '转课收据',
  },
  DynamicType: {
    1: '档案',
    2: '课后点评',
    3: '作业',
  },

  CouponType: {
    //优惠券类型
    1: '代金券',
    2: '折扣券',
    3: '课时券',
    4: '礼品券',
  },

  newCouponType: {
    CASH: { name: '代金券', class: 'cash' },
    DISCOUNT: { name: '折扣券', class: 'discount' },
    CLASS_HOUR: { name: '课时券', class: 'class-hour' },
    GIFT: { name: '礼品券', class: 'gift' },
  },

  ReserveStatus: {
    1: '可预约',
    2: '已预约',
    3: '已满员',
    4: '已结束',
  },
  ReserveStatusV5: {
    0: {
      value: '未开始',
      color: '#999999',
    },
    1: {
      value: '可预约',
      color: '#3296FA',
    },
    2: {
      value: '预约成功',
      color: '#3BBDAA',
    },
    3: {
      value: '已满员',
      color: '#EC5743',
    },
    4: {
      value: '已结束',
      color: '#999999',
    },
    5: {
      value: '可排队',
      color: '#FFAB1A',
    },
    6: {
      value: '排队中',
      color: '#FFAB1A',
    },
    7: {
      value: '排队取消',
      color: '#EC5743',
    },
  },
  QueueCancelEnum: {
    UNKNOWN_CODE: '',
    ADMIN_CANCEL: '教务取消',
    STUDENT_CANCEL: '学生取消',
    AUTO_CANCEL: '自动取消',
  },
  scheduleOperateENUM: {
    RESERVE: {
      value: '预约',
      color: '#3296FA',
    },
    CANCEL_RESERVE: {
      value: '取消预约',
      color: '#3296FA',
    },
    QUEUE_ENABLE: {
      value: '排队',
      color: '#FFAB1A',
    },
    CANCEL_QUEUE: {
      value: '取消排队',
      color: '#EC5743',
    },
  },
  studentScheduleENUM: {
    NOT_START: {
      value: '未开始',
      color: '#999999',
    },
    NORMAL: {
      value: '可预约',
      color: '#3296FA',
    },
    FULL: {
      value: '已满员',
      color: '#3296FA',
    },
    RESERVE: {
      value: '已预约',
      color: '#3BBDAA',
    },
    END: {
      value: '已结束',
      color: '#999999',
    },
    QUEUE: {
      value: '排队中',
      color: '#FFAB1A',
    },
    SUCCESS: {
      value: '排队成功',
      color: '#3BBDAA',
    },
    CANCEL: {
      value: '取消排队',
      color: '#EC5743',
    },
  },
  UnitState: {
    CLASS_HOUR: '课时',
    DAY: '天',
    MONTH: '月',
    PIECE: '件',
    PACKET: '笔',
  },
  // businessState: {
  //   'WAITING': '待支付',
  //   'ARREARS': '待补交',
  //   'PAID': '已支付',
  //   'CANCEL':'已取消',
  //   'DISCARD': '已作废',
  //   'TIMEOUT':'已取消',
  // },
  businessType: {
    SIGN_UP: '报名',
    TRANSFER_COURSE: '转课',
    REFUND_COURSE: '退课',
    REFUND_ITEM: '退物品',
    REFUND_FEE: '退费用',
    ACCOUNT_RECHARGE: '账户充值',
    ACCOUNT_REFUND: '账户退款',
    PURCHASE_CARD: '办卡',
    REFUND_CARD: '退卡',
  },
  businessState: {
    WAITING: { name: '待支付', color: '#FF4F4F' },
    ARREARS: { name: '待补交', color: '#FF4F4F' },
    PAID: { name: '已支付', color: '#58B7EF' },
    CANCEL: { name: '已取消', color: '#666666' },
    DISCARD: { name: '已作废', color: '#666666' },
    TIMEOUT: { name: '已取消', color: '#666666' },
    REFUND_FAILED:{name:'退款异常',color:'#666666'},
    REFUNDING:{name:'退款中',color:'#666666'}
  },
  businessSource: {
    ONLINE_MALL: '在线购买',
    OFFLINE_SOURCE: '机构创建',
    IMPORT: '导入订单',
    CROSS_INST: '学员转校',
  },
  itemUnit: {
    CLASS_HOUR: '课时',
    DAY: '天',
    MONTH: '月',
    PIECE: '件',
    PACKET: '笔',
  },
};

const PointsExchangeStatus = new Enum([
  {
    key: 'WATING_AUDIT',
    value: '待审核',
    color: '#FF8534',
    desc: '兑换申请已提交，等待机构确认',
  },
  {
    key: 'USER_CANCEL',
    value: '已撤销',
    color: '#999',
    desc: '消耗积分已返还至你的账户',
  },
  {
    key: 'WATING_DELIVER',
    value: '待发放',
    color: '#58B7EF',
    desc: '实物礼品请联系机构老师领取',
  },
  {
    key: 'FINISH_DELIVER',
    value: '已发放',
    color: '#3BBDAA',
    desc: '您已完成兑换！',
  },
]);

const dataBuriedMap = {
  archives: {
    event: 'C_GrowthArthivesAppointment',
    eventName: 'C端成长档案预约量',
  },
  comment: {
    event: 'C_CommentAppointment',
    eventName: 'C端课后点评预约量',
  },
  homework: {
    event: 'C_HomeworkAppointment',
    eventName: 'C端课后作业预约量',
  },
  transcript: {
    event: 'C_TranscriptAppointment',
    eventName: 'C端成绩单预约量',
  },
  artExhibition: {
    event: 'C_ArtExhibitionAppointment',
    eventName: 'C端3D艺术展',
  }
};

const FileVerifyMap = {
  'application/msword': {
    type: 'word',
    maxSize: 10,
  },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
    type: 'word',
    maxSize: 10,
  },
  'text/csv': {
    type: 'Excel',
    maxSize: 10,
  },
  'application/vnd.ms-excel': {
    type: 'Excel',
    maxSize: 10,
  },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
    type: 'Excel',
    maxSize: 10,
  },
  'application/wps-office.xls': {
    type: 'Excel',
    maxSize: 10,
  },
  'application/vnd.ms-powerpoint': {
    type: 'PPT',
    maxSize: 20,
  },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
    type: 'PPT',
    maxSize: 20,
  },
  'application/pdf': {
    type: 'PDF',
    maxSize: 50,
  },
  'application/wps-office.pdf': {
    type: 'PDF',
    maxSize: 50,
  },
  'image/jpeg': {
    type: 'JPG',
    maxSize: 10,
  },
  'audio/mpeg': {
    type: 'MP3',
    maxSize: 50,
  },
  'audio/mp3': {
    type: 'MP3',
    maxSize: 50,
  },
  'audio/mp4': {
    type: 'MP4',
    maxSize: 100,
  },
  'video/mp4': {
    type: 'MP4',
    maxSize: 100,
  },
};

const FileTypeIcon = {
  word: 'https://image.xiaomaiketang.com/xm/ey3FNcnsC8.png',
  WORD: 'https://image.xiaomaiketang.com/xm/ey3FNcnsC8.png',
  Excel: 'https://image.xiaomaiketang.com/xm/spz8KaAhfS.png',
  EXCEL: 'https://image.xiaomaiketang.com/xm/spz8KaAhfS.png',
  PPT: 'https://image.xiaomaiketang.com/xm/WfxmAnsXpc.png',
  PDF: 'https://image.xiaomaiketang.com/xm/jmAccyXdPp.png',
  MP3: 'https://image.xiaomaiketang.com/xm/G2YejNHMFf.png',
  MP4: 'https://image.xiaomaiketang.com/xm/s77zRpiARA.png',
  JPG: 'https://image.xiaomaiketang.com/xm/TZzbfnmtSS.png',
  BMP: 'https://image.xiaomaiketang.com/xm/TZzbfnmtSS.png',
  PNG: 'https://image.xiaomaiketang.com/xm/TZzbfnmtSS.png',
  GIF: 'https://image.xiaomaiketang.com/xm/TZzbfnmtSS.png',
};


export { PointsExchangeStatus, dataBuriedMap, FileTypeIcon, FileVerifyMap, physicalList };



// WEBPACK FOOTER //
// ./src/core/enum.js